import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const initialPath = process.env.MIX_APP_URL;
console.log(initialPath);
export default new Router({
    routes: [
        {
            path: initialPath + "/",
            // name: "InicioGeneral",
            component: require("./views/VistaVacia.vue").default,
            children: [
                {
                    path: "/",
                    name: "Inicio",
                    component: require("./views/Index.vue").default,
                },
                {
                    path: "buscador/:tipo",
                    name: "BuscadorGeneralFichas",
                    component: require("./views/BuscadorBeta.vue").default,
                },
            ],
        },
        {
            path: initialPath + "/reportes-general",
            // name: "index",
            component: require("./views/VistaVacia.vue").default,
            children: [
                {
                    path: "/",
                    name: "Index",
                    component: require("./views/ReporteGeneral.vue").default,
                },
            ],
        },
        {
            path: initialPath + "/busqueda",
            name: "indexBusquedas",
            component: require("./views/VistaVacia.vue").default,
            children: [
                {
                    path: "reporte",
                    name: "ReporteGeneralNew",
                    component: require("./views/ReporteGeneralNew.vue").default,
                },
                {
                    path: "reporte-beta",
                    name: "ReporteGeneralBeta",
                    component: require("./views/ReporteGeneralBeta.vue")
                        .default,
                },
                {
                    path: ":NC/:q/",
                    name: "Busquedas",
                    component: require("./views/Busquedas.vue").default,
                },
            ],
        },
        {
            path: initialPath + "/configuraciones",
            name: "indexConfiguraciones",
            component: require("./views/VistaVacia.vue").default,
            children: [
                {
                    path: "usuarios",
                    name: "UsuariosSearch",
                    component:
                        require("./views/configuraciones/usuarios/index.vue")
                            .default,
                },
                {
                    path: "usuarios/:id",
                    name: "UsuariosNew",
                    component:
                        require("./views/configuraciones/usuarios/crear.vue")
                            .default,
                },
                {
                    path: "sectores",
                    name: "SectoresSearch",
                    component:
                        require("./views/configuraciones/sectores/index.vue")
                            .default,
                },
                {
                    path: "sectores/:id",
                    name: "SectoresNew",
                    component:
                        require("./views/configuraciones/sectores/crear.vue")
                            .default,
                },
                {
                    path: "numeracion",
                    name: "NumeracionSearch",
                    component:
                        require("./views/configuraciones/numeracion/index.vue")
                            .default,
                },
                {
                    path: "numeracion/:id",
                    name: "NumeracionNew",
                    component:
                        require("./views/configuraciones/numeracion/crear.vue")
                            .default,
                },
            ],
        },
        {
            path: initialPath + "/registros",
            name: "indexRegistros",
            component: require("./views/VistaVacia.vue").default,
            children: [
                {
                    path: "acciones",
                    name: "RegistroAcciones",
                    component: require("./views/VistaVacia.vue").default,
                    children: [
                        {
                            path: "nuevo",
                            name: "NuevoRegistro",
                            component:
                                require("./views/registro/acciones/Nuevo.vue")
                                    .default,
                        },
                        {
                            path: "nuevo/:id",
                            name: "NuevoRegistroEditar",
                            component:
                                require("./views/registro/acciones/Nuevo.vue")
                                    .default,
                        },
                        {
                            path: "adjuntar-archivo",
                            name: "AdjuntarArchivoRegistro",
                            component:
                                require("./views/registro/acciones/AdjuntarArchivo.vue")
                                    .default,
                        },
                        {
                            path: "regresar-etapa",
                            name: "RegresarEtapaRegistro",
                            component:
                                require("./views/registro/acciones/RegresarEtapa.vue")
                                    .default,
                        },
                        {
                            path: "derivar-fichas",
                            name: "DerivarFichasRegistro",
                            component:
                                require("./views/registro/acciones/DerivarFichas.vue")
                                    .default,
                        },
                        {
                            path: "pendientes",
                            name: "PendientesRegistro",
                            component:
                                require("./views/registro/acciones/Pendientes.vue")
                                    .default,
                        },
                        {
                            path: "derivar-fichas/derivacion",
                            name: "FormularioDerivaRegistro",
                            component:
                                require("./views/registro/acciones/FormularioDeriva.vue")
                                    .default,
                            props: true,
                        },
                    ],
                },
                {
                    path: "configuracion",
                    name: "RegistroConfiguracion",
                    component: require("./views/VistaVacia.vue").default,
                    children: [
                        {
                            path: "tipos-registros/RE",
                            name: "TiposRegistro",
                            component:
                                require("./views/registro/configuracion/Tipos.vue")
                                    .default,
                        },
                        {
                            path: "tipos-registros/RE/editar/:id",
                            name: "TiposRegistroEdit",
                            component:
                                require("./views/registro/configuracion/NuevoTipo.vue")
                                    .default,
                        },
                        {
                            path: "clasificacion/RE",
                            name: "ClasificacionRegistro",
                            component:
                                require("./views/registro/configuracion/Clasificacion.vue")
                                    .default,
                        },
                        {
                            path: "etapas/RE",
                            name: "EtapasRegistro",
                            component:
                                require("./views/registro/configuracion/Etapas.vue")
                                    .default,
                        },
                        {
                            path: "procesos/RE",
                            name: "ProcesosRegistro",
                            component:
                                require("./views/registro/configuracion/Procesos.vue")
                                    .default,
                        },
                        {
                            path: "accesos/RE",
                            name: "AccesosRegistro",
                            component:
                                require("./views/registro/configuracion/Accesos.vue")
                                    .default,
                        },
                        {
                            path: "adicionales-etapa/RE",
                            name: "AdicionalesEtapasRegistro",
                            component:
                                require("./views/registro/configuracion/AdicionalesEtapas.vue")
                                    .default,
                        },
                        {
                            path: "matriz/RE",
                            name: "MatrizRegistro",
                            component:
                                require("./views/registro/configuracion/Matriz.vue")
                                    .default,
                        },
                        {
                            path: "configuracion-adicionales/RE",
                            name: "ConfiguracionAdicionalesRegistro",
                            component:
                                require("./views/registro/configuracion/ConfiguracionAdicionales.vue")
                                    .default,
                        },
                    ],
                },
            ],
        },
        {
            path: initialPath + "/informacion-documentada",
            name: "indexID",
            component: require("./views/VistaVacia.vue").default,
            children: [
                {
                    path: "acciones",
                    name: "InformacionDocumentadaAcciones",
                    component: require("./views/VistaVacia.vue").default,
                    children: [
                        {
                            path: "pendientes",
                            name: "PendientesInformacionDocumentada",
                            component:
                                require("./views/informacion_documentada/acciones/Pendientes.vue")
                                    .default,
                        },
                        {
                            path: "derivar-fichas/derivacion",
                            name: "FormularioDerivaInformacionDocumentada",
                            component:
                                require("./views/informacion_documentada/acciones/FormularioDeriva.vue")
                                    .default,
                            props: true,
                        },
                    ],
                },
            ],
        },
        {
            path: initialPath + "/fichas/:lugar",
            name: "indexFichas",
            component: require("./views/VistaVacia.vue").default,
            children: [
                {
                    path: "acciones",
                    name: "FichasAcciones",
                    component: require("./views/VistaVacia.vue").default,
                    children: [
                        {
                            path: "crear",
                            name: "FichasCrear",
                            component:
                                require("./views/fichas/acciones/Nuevo.vue")
                                    .default,
                            props: true,
                        },
                        {
                            path: "nuevo/:id",
                            name: "FichasEditar",
                            component:
                                require("./views/fichas/acciones/Nuevo.vue")
                                    .default,
                        },
                        {
                            path: "pendientes",
                            name: "PendientesFicha",
                            component:
                                require("./views/fichas/acciones/Pendientes.vue")
                                    .default,
                        },
                        {
                            path: "adjuntar-archivo",
                            name: "AdjuntarArchivoFicha",
                            component:
                                require("./views/fichas/acciones/AdjuntarArchivo.vue")
                                    .default,
                        },
                        {
                            path: "derivacion",
                            name: "FormularioDerivaFichas",
                            component:
                                require("./views/fichas/acciones/FormularioDeriva.vue")
                                    .default,
                            props: true,
                        },
                    ],
                },
                {
                    path: "confguraciones",
                    name: "FichasConfiguraciones",
                    component: require("./views/VistaVacia.vue").default,
                    children: [
                        {
                            path: "nueva-etapa",
                            name: "NuevaEtapa",
                            component:
                                require("./views/fichas/configuraciones/NuevaEtapa.vue")
                                    .default,
                            props: true,
                        },
                        {
                            path: "nueva-etapa/:id",
                            name: "NuevaEtapaEditar",
                            component:
                                require("./views/fichas/configuraciones/NuevaEtapa.vue")
                                    .default,
                            props: true,
                        },
                    ],
                },
            ],
        },
    ],
    mode: "history",
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
});
